"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _styles = require("../../styles");

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var _isHexColorValue = _interopRequireDefault(require("../../is-hex-color-value"));

var _axisLabelFormatters = require("../../label-formatters/axis-label-formatters");

var DEFAULT_COLOR_INDEX = 9;
var DEFAULT_SERIES_COLOR = _styles.DEFAULT_SERIES_CHART_COLORS[DEFAULT_COLOR_INDEX];

var DEFAULT_DATALABEL_FORMATTER = function DEFAULT_DATALABEL_FORMATTER() {};

var DEFAULT_ON_ERROR_HANDLER = function DEFAULT_ON_ERROR_HANDLER() {};

var DEFAULT_ON_POINT_CLICK = undefined;

var DEFAULT_TOOLTIP_FORMATTER = function DEFAULT_TOOLTIP_FORMATTER(options) {
  return "".concat(options.seriesName, ", ").concat(options.key, ": ").concat(options.value.toLocaleString('en-US'));
};

var DEFAULT_X_AXIS_LABEL_FORMATTER = _axisLabelFormatters.AxisLabelFormatters.PASS_THROUGH;
var DEFAULT_Y_AXIS_LABEL_FORMATTER = _axisLabelFormatters.AxisLabelFormatters.PASS_THROUGH;
/**
 * @callback MwChartHeatmapDataLabelFormatter
 *
 * Custom behavior to format the label for a data value.
 *
 * @param {MwChartHeatmapLabelFormatterOptions} options Options provided by the chart
 * @returns {function} Function callback.
 */

/**
 * @callback MwChartHeatmapClick
 *
 * Custom behavior to handle a click on a column.
 *
 * @param {MwChartHeatmapClickOptions} options Options provided by the chart
 * @returns {function} Function callback.
 */

/**
 * @callback MwChartHeatmapAxisLabelFormatter
 *
 * Custom behavior to format the label for a particular mark on the x-axis.
 *
 * @param {AxisLabelFormatterOptions} options Options provided by the chart
 * @returns {string} Text to show as the x-axis label
 */

/**
 * @callback MwChartHeatmapTooltipFormatter
 *
 * Custom behavior to format the string of the tooltip.
 *
 * @param {TooltipFormatterOptions} options Options provided by the chart
 * @returns {string} Text to show as the formatted tooltip
 */

/**
 * @callback MwChartHeatmapOnErrorCallback
 *
 * Custom behavior to be called when an error occurs.
 *
 * @param {TooltipOnError} boolean boolean to dictate whether or not to there is an error
 */

/**
 * A class to represent the visualization options for Heatmap
 * @param {boolean} [options.animate=true] boolean to dictate whether or not to animate the chart.
 * @param {boolean} [options.hideLegend=false] boolean to dictate whether or not to hide legend.
 * @param {MwChartHeatmapOnErrorCallback} [options.onError] A function to handle the OnError event
 * @param {MwChartHeatmapDataLabelFormatter} [options.dataLabelFormatter] A function to be passed a value to format data label
 * @param {string} [options.seriesColor] - A hex color value for the one series color (Eg #ffbbcc). If not provided default color will be displayed.
 * @param {MwChartHeatmapClick} [options.onPointClick] - A function to be passed a point data object (ie seriesIndex, columnName, value) on click
 * @param {MwChartHeatmapTooltipFormatter} [options.tooltipFormatter] Custom handler to format tooltips
 * @param {MwChartHeatmapAxisLabelFormatter|AxisLabelFormatter} [options.xAxisLabelFormatter] Custom handler to format x-axis labels
 * @param {MwChartHeatmapAxisLabelFormatter|AxisLabelFormatter} [options.yAxisLabelFormatter=AxisLabelFormatters.DEFAULT_NUMBER_LABEL] A function to format y-axis labels, or a named AxisLabelFormatter. If provided a function, the function is provided AxisLabelFormatterOptions.
 */

var MwChartHeatmapOptions =
/* eslint-disable-next-line complexity */
function MwChartHeatmapOptions(options) {
  (0, _classCallCheck2.default)(this, MwChartHeatmapOptions);
  var safeOptions = (0, _getValidObject.default)(options);

  if (safeOptions.animate === undefined) {
    safeOptions.animate = true;
  } else {
    _argumentContracts.default.assertBoolean(safeOptions.animate, 'options.animate');
  }

  if (safeOptions.hideLegend === undefined) {
    safeOptions.hideLegend = false;
  } else {
    _argumentContracts.default.assertBoolean(safeOptions.hideLegend, 'options.hideLegend');
  }

  if (safeOptions.onError === undefined) {
    safeOptions.onError = DEFAULT_ON_ERROR_HANDLER;
  } else {
    _argumentContracts.default.assertFunction(safeOptions.onError, 'options.onError');
  }

  if (safeOptions.onPointClick === undefined) {
    safeOptions.onPointClick = DEFAULT_ON_POINT_CLICK;
  } else {
    _argumentContracts.default.assertFunction(safeOptions.onPointClick, 'options.onPointClick');
  }

  if (safeOptions.tooltipFormatter === undefined) {
    safeOptions.tooltipFormatter = DEFAULT_TOOLTIP_FORMATTER;
  } else {
    _argumentContracts.default.assertFunction(safeOptions.tooltipFormatter, 'options.tooltipFormatter');
  }

  if (safeOptions.xAxisLabelFormatter === undefined) {
    safeOptions.xAxisLabelFormatter = DEFAULT_X_AXIS_LABEL_FORMATTER;
  } else if (typeof safeOptions.xAxisLabelFormatter === 'string') {
    if (!(0, _axisLabelFormatters.isValidAxisLabelFormatter)(safeOptions.xAxisLabelFormatter)) {
      throw new TypeError("options.xAxisLabelFormatter must be a known AxisLabelFormatter. Provided: ".concat(safeOptions.xAxisLabelFormatter));
    }
  } else {
    _argumentContracts.default.assertFunction(safeOptions.xAxisLabelFormatter, 'options.xAxisLabelFormatter');
  }

  if (safeOptions.yAxisLabelFormatter === undefined) {
    safeOptions.yAxisLabelFormatter = DEFAULT_Y_AXIS_LABEL_FORMATTER;
  } else if (typeof safeOptions.yAxisLabelFormatter === 'string') {
    if (!(0, _axisLabelFormatters.isValidAxisLabelFormatter)(safeOptions.yAxisLabelFormatter)) {
      throw new TypeError("options.yAxisLabelFormatter must be a known AxisLabelFormatter if provided as a string. Provided: ".concat(JSON.stringify(safeOptions.yAxisLabelFormatter)));
    }
  } else {
    _argumentContracts.default.assertFunction(options.yAxisLabelFormatter, 'options.yAxisLabelFormatter');
  }

  if (safeOptions.dataLabelFormatter === undefined) {
    safeOptions.dataLabelFormatter = DEFAULT_DATALABEL_FORMATTER;
  } else {
    _argumentContracts.default.assertFunction(safeOptions.dataLabelFormatter, 'options.dataLabelFormatter');
  }

  if (!safeOptions.seriesColor) {
    safeOptions.seriesColor = DEFAULT_SERIES_COLOR;
  } else if (!(0, _isHexColorValue.default)(safeOptions.seriesColor)) {
    throw new TypeError("options.seriesColor must be a valid hex color value. Provided value: ".concat(safeOptions.seriesColor));
  }

  this.animate = safeOptions.animate;
  this.dataLabelFormatter = safeOptions.dataLabelFormatter;
  this.onError = safeOptions.onError;
  this.seriesColor = safeOptions.seriesColor;
  this.hideLegend = safeOptions.hideLegend;
  this.onError = safeOptions.onError;
  this.onPointClick = safeOptions.onPointClick;
  this.tooltipFormatter = safeOptions.tooltipFormatter;
  this.xAxisLabelFormatter = safeOptions.xAxisLabelFormatter;
  this.yAxisLabelFormatter = safeOptions.yAxisLabelFormatter;
  Object.freeze(this);
};

exports.default = MwChartHeatmapOptions;